import Core from '@/core/core/core';
import Events from '@/core/core/events';
import Worker from '@/components/popup/lib/worker';

/**
 * Глобальные события, для реализации Popup
 */
class WorkerEvents {

	private static isInited = false;

	/**
	 * Добавить глобальные обработчики
	 *
	 * Добавляются на страницу один раз и навсегда
	 */
	static init(): void {
		if (this.isInited) return;

		this.isInited = true;

		// автоматическое открытие при наведении мыши, событие глобальное, так как инициализация popup отложена
		document.addEventListener('mouseover', (e) => {
			if (!(e.target instanceof HTMLElement) || !e.target.dataset?.topPopupOpenByHover) {
				return;
			}

			e.target.click();
		});

		// при скролле страницы закрыть Popup
		document.addEventListener('scroll', () => {
			if (Core.state.isMobile || Core.state.isMobileUA) {
				return;
			}

			Worker.getAll().forEach(elPopup => Worker.close(elPopup));
		});

		Events.addOnReize(e => {
			// закрыть popup при повороте экрана телефона
			// если была отображена ПК версия, она будет закрыта
			if (Core.state.isMobile && e.topEvent.widthDiff) {
				Worker.getAll().forEach(elPopup => Worker.close(elPopup));
			}
		});

		document.addEventListener('click', this.onclick, { capture: true });
	}

	/**
	 * Глобальный обработчик кликов
	 *
	 * Обрабатывает клики на открытие Popup
	 */
	private static async onclick(e: Event): Promise<void> {
		if (!(e.target instanceof HTMLElement)) return;

		if (e.target.dataset.topPopupDisabled) {
			return;
		}

		let elOpener: HTMLElement | undefined;

		switch (true) {
			case !!e.target.dataset?.topPopup:
				elOpener = e.target;

				break;

			case !!e.target.parentElement?.dataset.topPopup:
				elOpener = e.target.parentElement;

				break;

			case !!e.target.parentElement?.parentElement?.dataset.topPopup:
				elOpener = e.target.parentElement?.parentElement;

				break;
		}

		if (!elOpener) {
			return;
		}

		if (elOpener.dataset.topPopupDisabled) {
			return;
		}

		// меню уже открыто
		if (elOpener.dataset.topPopupOpened) {
			return;
		}

		e.preventDefault();

		await Worker.openByOpener(elOpener);
	}
}

export default WorkerEvents;
